module.exports = __webpack_public_path__ + "img/moringa-350x184.59d3c7ca.jpg";